<template>

      <div class="item">
        <!-- <a class="play_btn" @click="$emit('play', item)"><i class="fas fa-play"></i></a> -->
        
        <span class="num">{{item.total_views}} <p>האזנות</p></span>

        <div class="pic" :style="'background-image:url(' + item.pic_tumb + ')'" @click="$emit('open_widget')"></div>
        
        <div class="texts">
            <!-- <h3 v-text="item.artist.name"></h3> -->
            <h4 v-text="item.name"></h4>
        </div>
          
        <span class="duration show_in_desktop" v-text="item.total_time"></span>
          <span class="date show_in_desktop" v-text="item.online_date_format"></span>

        <div class="option" @click="$emit('itemOpen')" :class="active"><i class="fas fa-chart-area"></i><p>סטטיסטיקות</p></div>
        <div class="option show_in_desktop" @click="$emit('open_widget')"><img src="@/assets/to_lt.svg" style="height:35px;"><p>הצג לינקטון</p></div>
        <div class="share show_in_desktop">
          <!-- <div class="icon"><i class="fas fa-pencil-alt"></i></div> -->
          <div class="icon" @click="$bus.$emit('share_url', item.link)"><i class="fas fa-share-alt"></i></div>
          <!-- <div class="icon"><i class="far fa-trash-alt"></i></div> -->
        </div>
      </div>
</template>
<style scoped lang="scss">
.item{
  .share{display: flex;}
  .share{
    .icon{margin: 0 10px;font-size: 14px;border: 1px solid;padding: 0px;border-radius: 100%;line-height: 1px;cursor: pointer; width:30px; height: 30px; text-align: center; line-height: 30px;}
    .icon:hover{transform: scale(1.04);}
  }
  .texts{
    h4{color: #000 !important;padding-right: 25px;}
  }
.num{
  &{    font-size: 51px; color: #ff1661 !important;}
  p{    font-size: 17px; margin-top: 4px;}
}
.active{color: #ff1661;}
.option{ text-align: center;cursor: pointer;font-size: 16px;font-weight: 700;
  
  @media (min-width: 600px) { width: 10%; }
  @media (max-width: 600px) { }
  .svg-inline--fa{    font-size: 35px;text-align: center;margin-bottom: -3px;}
}
}
</style>

<script>
  
export default {
  props: ["item" ,"active"],
  data(){
    return {
    }
  },
  methods: {

  }
}
</script>